import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import Masked from "react-text-mask";
import { createAutoCorrectedDatePipe, createNumberMask, emailMask } from "text-mask-addons";
import { createAutoCorrectedRangePipe, currencyMaskOptions, dateMask, rangeDateMask, } from "../helpers/masks";
import { Input } from "./Input";
export const MaskedInput = ({ maskOptions, maskType, size: _, dateFormat, maskProps, ...inputProps }) => {
    const options = useMemo(() => {
        if (maskProps) {
            return maskProps;
        }
        const options = {
            mask: [],
        };
        switch (maskType) {
            case "currency":
                options.mask = createNumberMask(currencyMaskOptions);
                break;
            case "email":
                options.mask = emailMask;
                break;
            case "date":
                options.mask = dateMask;
                options.pipe = createAutoCorrectedDatePipe(dateFormat?.toLowerCase() || "mm/dd/yyyy");
                options.guide = true;
                options.keepCharPositions = true;
                options.placeholderChar = "_";
                break;
            case "range":
                options.mask = rangeDateMask;
                options.pipe = createAutoCorrectedRangePipe(dateFormat?.toLowerCase() || "mm/dd/yyyy");
                options.guide = true;
                options.keepCharPositions = true;
                options.placeholderChar = "_";
                break;
            case "custom":
                options.mask = maskOptions || [];
        }
        return options;
    }, [dateFormat, maskOptions, maskProps, maskType]);
    return (_jsx(Masked, { ...options, ...inputProps, render: (ref, { defaultValue: _, ...props }) => (_jsx(Input, { ref: ref, ...inputProps, ...props })) }));
};
